/* eslint-disable */
export enum TipoDocumento {   
    LC = 1,
    LE = 2,
    CI = 3,
    PASAPORTE = 4,
    DU = 5,
    DNI = 6
}
